import { isWaybetterProduct } from '../utils';
import { encode } from '../base64';

import { asQueryString, productUrlPrefix } from './url-utils';

/**
 * URL versions indicate evolution of the cart, as follows:
 * - No version: A new Figma design from Sept 2023 that (New design matches branding in colors / typography / etc. The quiz got a lift in trial signups after the designs were changed to match our branding, we are experimenting to see if it will have the same effect on the cart)
 * - v1: the original cart implementation as of 09/22/2023 (the v1 path was created in contentful, and will probably be deleted after the experiment, a duplicate of the cart had to be made for this experiment so that we can AB test based off of namespace)
 */

export const checkoutUrl = ({
  product = 'waybetter',
  orderId,
  cartVariant,
  orderItemInputs, // used to recreate the order if a different user hits the cart url (see WBRT-2171)
  version, // used to ab test based on formsort redirect TODO: remove this after experiment
}) => {
  const checkoutSlug = isWaybetterProduct(product) ? 'checkout' : 'paybet';
  const prefixSlug = productUrlPrefix(product);
  const query = asQueryString({
    cartVariant,
    oii: orderItemInputs ? encode(orderItemInputs) : undefined,
  });
  const variantCheckoutExp =
    version === 'v1' ? `${checkoutSlug}/v1` : checkoutSlug; // v1 is used for the old cart, the new cart will not have a version on the url path

  return `${prefixSlug}/${variantCheckoutExp}/${orderId}?${query}`;
};
